import React, { createContext, useContext, useState } from "react";
import AlertCustom from "../components/AlertCustom/AlertCustom";

const AlertContext = createContext();
export const useAlert = () => useContext(AlertContext);

let alertIdCounter = 0;

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = ({ title, message, variant = "success" }) => {
    const id = ++alertIdCounter;
    setAlerts((prev) => [...prev, { id, title, message, variant }]);
  };

  const removeAlert = (id) => {
    setAlerts((prev) => prev.filter((alert) => alert.id !== id));
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <div className="alert-wrapper">
        {alerts.map((alert, row) => (
          <AlertCustom
            key={alert.id}
            {...alert}
            onClose={() => removeAlert(alert.id)}
          />
        ))}
      </div>
    </AlertContext.Provider>
  );
};
